import callApi from "Common/utils/apiCaller";
import BreadCrumb from "../../Common/BreadCrumb";
import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";

const DashBoard = () => {
  
  const [stats, setStats] = useState<any>(null);

  useEffect(() => {
    const fetchStats = async () => {

      const response = await callApi(
        "v1/admin/dashboard-stats",
        "post",
        {}
      );
      if (response.status === "Success") {
        setStats(response.data.stats);
      }
    };
    fetchStats();
  }, []);

  return (
    <>
      <BreadCrumb title="Dashboard" pageTitle="Dashboard" version="" />

      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="!py-3.5 card-body border-slate-200 dark:border-zink-500">
            <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
              <div className="relative flex items-center gap-2 xl:col-span-2">
                Welcome to indxx!
              </div>
            </div>
            <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">

            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-x-5">
        {stats && (
          <>
            {Object.keys(stats).map((key) => (
              <div key={key} className="col">
                <div className="p-4 card rounded shadow mb-4">
                  <h3 className="text-lg font-semibold">{_.startCase(key)}</h3>
                  <p className="mt-2 text-2xl">{stats[key]}</p>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default DashBoard;
